import api from './api';
import { Ramo, Linea, Clase, PagedResult } from '../types';

export const catalogosService = {
  // Ramos
  getRamos: async (pageNumber: number, pageSize: number, searchTerm?: string): Promise<PagedResult<Ramo>> => {
    const response = await api.get<PagedResult<Ramo>>('/api/catalogos/ramos', {
      params: { pageNumber, pageSize, searchTerm }
    });
    return response.data;
  },

  getRamo: async (codigoRamo: string): Promise<Ramo> => {
    const response = await api.get<Ramo>(`/api/catalogos/ramos/${codigoRamo}`);
    return response.data;
  },

  createRamo: async (ramo: Ramo): Promise<Ramo> => {
    const response = await api.post<Ramo>('/api/catalogos/ramos', ramo);
    return response.data;
  },

  updateRamo: async (codigoRamo: string, ramo: Ramo): Promise<Ramo> => {
    const response = await api.put<Ramo>(`/api/catalogos/ramos/${codigoRamo}`, ramo);
    return response.data;
  },

  deleteRamo: async (codigoRamo: string): Promise<void> => {
    await api.delete(`/api/catalogos/ramos/${codigoRamo}`);
  },

  // Líneas
  getLineas: async (
    pageNumber: number, 
    pageSize: number, 
    searchTerm?: string, 
    codigoRamo?: string
  ): Promise<PagedResult<Linea>> => {
    const response = await api.get<PagedResult<Linea>>('/api/catalogos/lineas', {
      params: { 
        pageNumber, 
        pageSize, 
        searchTerm, 
        codigoRamo 
      }
    });
    return response.data;
  },

  getLinea: async (codigoLinea: string): Promise<Linea> => {
    const response = await api.get<Linea>(`/api/catalogos/lineas/${codigoLinea}`);
    return response.data;
  },

  createLinea: async (linea: Linea): Promise<Linea> => {
    const response = await api.post<Linea>('/api/catalogos/lineas', linea);
    return response.data;
  },

  updateLinea: async (codigoLinea: string, linea: Linea): Promise<Linea> => {
    const response = await api.put<Linea>(`/api/catalogos/lineas/${codigoLinea}`, linea);
    return response.data;
  },

  deleteLinea: async (codigoLinea: string): Promise<void> => {
    await api.delete(`/api/catalogos/lineas/${codigoLinea}`);
  },

  // Clases
  getClases: async (pageNumber: number, pageSize: number, searchTerm?: string, codigoRamo?: string, codigoLinea?: string): Promise<PagedResult<Clase>> => {
    const response = await api.get<PagedResult<Clase>>('/api/catalogos/clases', {
      params: { pageNumber, pageSize, searchTerm, codigoRamo, codigoLinea }
    });
    return response.data;
  },

  getClase: async (codigoClase: string): Promise<Clase> => {
    const response = await api.get<Clase>(`/api/catalogos/clases/${codigoClase}`);
    return response.data;
  },

  createClase: async (clase: Clase): Promise<Clase> => {
    const response = await api.post<Clase>('/api/catalogos/clases', clase);
    return response.data;
  },

  updateClase: async (codigoClase: string, clase: Clase): Promise<Clase> => {
    const response = await api.put<Clase>(`/api/catalogos/clases/${codigoClase}`, clase);
    return response.data;
  },

  deleteClase: async (codigoClase: string): Promise<void> => {
    await api.delete(`/api/catalogos/clases/${codigoClase}`);
  }
}; 